import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { ActionModalComponent } from './components/action-modal/action-modal.component';
import { AdaptiveCardComponent } from './components/adaptive-card/adaptive-card.component';
import { AdminGroupedSelectorComponent } from './components/admin-grouped-selector/admin-grouped-selector.component';
import { AnswerGeneratedComponent } from './components/answer-generated/answer-generated.component';
import { DataSourcesDocumentsComponent } from './components/data-sources-documents/data-sources-documents.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import DrowpdownComponent from './components/dropdown/dropdown.component';
import { DrowpdownProfileComponent } from './components/dropdown-profile/dropdown-profile.component';
import { EditorOverlayComponent } from './components/editor-overlay/editor-overlay.component';
import { ErrorStatusModalComponent } from './components/error-status-modal/error-status-modal.component';
import { ExploreMindsCardComponent } from './components/explore-minds-card/explore-minds-card.component';
import { FileStatusChipComponent } from './components/file-status-chip/file-status-chip.component';
import { FooterComponent } from './components/footer/footer.component';
import { HistoricalChatsComponent } from './components/historical-chats/historical-chats.component';
import { HistoricalModalComponent } from './components/historical-modal/historical-modal.component';
import { HistoryNotFoundComponent } from './components/history-not-found/history-not-found.component';
import { LandingModalComponent } from './components/landing-modal/landing-modal.component';
import { LegalDisclaimerComponent } from './components/legal-disclaimer/legal-disclaimer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MercerAiReferencedComponent } from './components/mercer-ai-referenced/mercer-ai-referenced.component';
import { MercerMindLoaderComponent } from './components/mercer-mind-loader/mercer-mind-loader.component';
import { FileUploadComponent } from './components/mercer-mind-search-input/components/file-upload/file-upload.component';
import { SearchInputFilesComponent } from './components/mercer-mind-search-input/components/search-input-files/search-input-files.component';
import { MerecerMindSearchInputComponent } from './components/mercer-mind-search-input/mercer-mind-search-input.component';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { NavigateButtonsPageComponent } from './components/navigate-buttons-page/navigate-buttons-page.component';
import { NewChatButtonComponent } from './components/new-chat-button/new-chat-button.component';
import { PillComponent } from './components/pill/pill.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { ResourcesCardComponent } from './components/resources-card/resources-card.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SearchboxComponent } from './components/searchbox/searchbox.component';
import { SelectCheckeableComponent } from './components/select-checkable/select-checkeable.component';
import { SidebarFooterComponent } from './components/sidebar-footer/sidebar-footer.component';
import SpinnerComponent from './components/spinner/spinner.component';
import SpringboardHeaderComponent from './components/springboard-header/springboard-header.component';
import SuccessErrorBoxComponent from './components/success-error-box/success-error-box.component';
import SuggestedPromptsComponent from './components/suggested-prompts/suggested-prompts.component';
import TableComponent from './components/table/table.component';
import ToastOutletComponent from './components/toast-outlet/toast-outlet.component';
import { ToastOutletService } from './components/toast-outlet/toast-outlet.service';
import UnauthorizedMessageComponent from './components/unauthorized-message/unauthorized-message.component';
import { UploadProgressBarComponent } from './components/upload-progress-bar/upload-progress-bar.component';
import { AidaTooltipDirective } from './directives/aida-tooltip.directive';
import AutoExpandDirective from './directives/auto-expand.directive';
import StringListFilterPipe from './directives/string-list-filter.pipe';
import TypingEffectDirective from './directives/typing-effect.directive';
import FormErrorsPipe from './pipes/form-errors.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';

const COMPONENTS = [
    SearchInputComponent,
    SearchboxComponent,
    MercerAiReferencedComponent,
    MultiselectComponent,
    ResourcesCardComponent,
    FooterComponent,
    SpinnerComponent,
    DataSourcesDocumentsComponent,
    LandingModalComponent,
    NavigateButtonsPageComponent,
    SuccessErrorBoxComponent,
    MerecerMindSearchInputComponent,
    AdaptiveCardComponent,
    MercerMindLoaderComponent,
    ExploreMindsCardComponent,
    SpringboardHeaderComponent,
    LoaderComponent,
    DeleteModalComponent,
    ErrorStatusModalComponent,
    AnswerGeneratedComponent,
    ActionModalComponent,
    DrowpdownComponent,
    SuggestedPromptsComponent,
    SidebarFooterComponent,
    ToastOutletComponent,
    SelectCheckeableComponent,
    NewChatButtonComponent,
    UnauthorizedMessageComponent,
    TableComponent,
    PillComponent,
    EditorOverlayComponent,
    FileUploadComponent,
    SearchInputFilesComponent,
    DrowpdownProfileComponent,
    HistoryNotFoundComponent,
    PreloaderComponent,
    FileStatusChipComponent,
    AdminGroupedSelectorComponent,
    HistoricalChatsComponent,
    HistoricalModalComponent,
    UploadProgressBarComponent,
];

const DIRECTIVES = [StringListFilterPipe, FormErrorsPipe, AutoExpandDirective, TruncatePipe];

@NgModule({
    declarations: [...COMPONENTS, ...DIRECTIVES],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        MatTooltipModule,
        TypingEffectDirective,
        AidaTooltipDirective,
        LegalDisclaimerComponent,
    ],
    exports: [
        ...COMPONENTS,
        ...DIRECTIVES,
        MatTooltipModule,
        TypingEffectDirective,
        AidaTooltipDirective,
        LegalDisclaimerComponent,
    ],
    providers: [ToastOutletService],
})
export default class SharedModule {}
